export default __webpack_public_path__ + "static/media/catalogImage.40b9b36f.png";